export default __webpack_public_path__ + "/dist/images/faq-inactive.b2c44235792c3a44daf49ed299dfd044.svg";